import { render, staticRenderFns } from "./MeetingTypeCard.vue?vue&type=template&id=d546c0c4&scoped=true&"
import script from "./MeetingTypeCard.vue?vue&type=script&lang=js&"
export * from "./MeetingTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./MeetingTypeCard.vue?vue&type=style&index=0&id=d546c0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d546c0c4",
  null
  
)

export default component.exports